import { ChatWizIcon } from "./ChatWizIcon";
import { Image } from "@mantine/core";
import logo from "../../assets/Logo-black.svg";
import logoWhite from "../../assets/Logo-white.svg";

interface Props {
  isSmall?: boolean;
  isLoginPage?: boolean;
  color?: "black" | "white";
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
}

/**
 * Renders the SmartWiz logo component.
 *
 * @param {boolean} isSmall - Indicates whether the logo should be rendered in a small size.
 * @param {string} size - Specifies the size of the logo.
 * @return {JSX.Element} The SmartWiz logo component.
 */
const SmartWizLogo = ({
  isSmall,
  isLoginPage,
  size,
  color = "black",
}: Props) => {
  const sizeMap: Record<string, string> = {
    xs: "5rem",
    sm: "7rem",
    md: "10rem",
    lg: "14rem",
    xl: "18rem",
    xxl: "22rem",
  };

  const widthValue = size
    ? sizeMap[size]
    : isLoginPage
      ? "5.09753rem"
      : "14.375rem";

  return (
    <div className="logo">
      <ChatWizIcon isLoginPage={isLoginPage} />
      <Image
        className="logo-black"
        src={color === "white" ? logoWhite : logo}
        alt="logo"
        style={{
          width: isSmall ? "10.19506rem" : widthValue,
        }}
      />
    </div>
  );
};

export default SmartWizLogo;
